import Immutable from 'immutable';

const messageRecord = Immutable.Record({
    id: null,
    type: null,
    data: null,
    body: "",
    url: null,
    vidUrl: null,
    linkUrl: null,
    previewTitle: null,
    previewDescription: null,
    icon: null,
    isOwnedByUser: null
});

const initialMessageState = Immutable.List([]);

const messages = (state = initialMessageState, action) => {

    switch (action.type) {
        case 'ADD_RESPONSE': {
            const newMessage = messageRecord({
                id: action.message.id,
                body: action.message.body,
                url: action.message.pic_url,
                vidUrl: action.message.vid_url,
                type: action.message.type,
                linkUrl: action.message.linkUrl,
                previewTitle: action.message.previewTitle,
                previewDescription: action.message.previewDescription,
                icon: action.message.icon,
                isOwnedByUser: false
            });
            return state.push(newMessage);
        }
        case 'UPDATE_RESPONSE': {
            const responseIndex = state.findIndex(obj => {
                return obj.id === action.message.id
            });
            return state.mergeIn([responseIndex], action.message);
        }
        case 'ADD_MESSAGE': {
            const newMessage = messageRecord({
                body: action.message,
                data: action.data || null,
                type: action.data ? "trigger" : "text",
                isOwnedByUser: true
            });
            return state.push(newMessage);
        }
        case 'ADD_MESSAGE_FROM_HISTORY': {
            const newMessage = messageRecord({
                id: action.message.message.id,
                body: action.message.message.body || action.message.message.title,
                isOwnedByUser: action.message.own,
                url: action.message.message.pic_url,
                vidUrl: action.message.message.vid_url,
                type: action.message.message.type,
                linkUrl: action.message.message.url,
                previewTitle: action.message.message.previewTitle,
                previewDescription: action.message.message.previewDescription,
                icon: action.message.message.icon
            });
            return state.push(newMessage);
        }
        case 'DELETE_MESSAGES': {
            return state.clear();
        }
        default:
            return state;
    }
}

export default messages;



// WEBPACK FOOTER //
// ./src/reducers/messages.js